import { Typography } from 'components/typography';
import { cn } from 'utils/shadcn';

export type CompletedSuggestionStatus = {
  key: string;
  count: number;
  // Text color class for the status dot and its count
  colorClass: string;
};

type CompletedSuggestionsToggleProps = {
  showCompleted: boolean;
  onToggle: () => void;
  viewCompletedLabel: string;
  viewPendingLabel: string;
  statuses: CompletedSuggestionStatus[];
};

// Text link above the Kit list that swaps the pending suggestions for the handled quotes and built
// loads. Closed, it shows a colored count dot per status.
export function CompletedSuggestionsToggle({
  showCompleted,
  onToggle,
  viewCompletedLabel,
  viewPendingLabel,
  statuses,
}: CompletedSuggestionsToggleProps) {
  return (
    <button
      type='button'
      onClick={onToggle}
      className='self-end cursor-pointer border-none bg-transparent px-1 text-xs font-medium text-accent-700 underline underline-offset-2 hover:text-accent-800 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-accent-400'
      aria-pressed={showCompleted}
    >
      <Typography
        as='span'
        variant='body-xs'
        weight='medium'
        className='text-accent-700'
      >
        {showCompleted ? viewPendingLabel : viewCompletedLabel}
      </Typography>
      {!showCompleted && (
        <span
          aria-hidden='true'
          className='ml-1 inline-flex items-center gap-[3px]'
          data-testid='handled-quote-statuses'
        >
          {statuses.map(({ key, count, colorClass }) => (
            <span
              key={key}
              className={cn(
                'inline-flex items-center gap-0.5 text-[10px]',
                colorClass
              )}
            >
              <span className='h-1.5 w-1.5 rounded-full bg-current' />
              {count}
            </span>
          ))}
        </span>
      )}
    </button>
  );
}
